export interface IDashDrugUse {
    
}